import React from "react";
import { string } from "prop-types";

import "./textfield.m.css";

const TextField = ({ value, type, error, label, ...props }) => (
  <div styleName="wrapper" className="wrapper-textfield">
    {label && <label styleName="label">{label}</label>}
    <input type={type} value={value} styleName="textfield" {...props} className="textfield" />
    {error && <span styleName="error">{error}</span>}
  </div>
);

TextField.defaultProps = {
  type: "text"
};

TextField.propTypes = {
  type: string,
  value: string,
  error: string,
  label: string
};

export default TextField;
